var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    r: 18,
    cy: 18,
    cx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "m17.874116,17.170077c2.21,0 4,-1.79 4,-4s-1.79,-4 -4,-4s-4,1.79 -4,4s1.79,4 4,4zm0,2c-2.67,0 -8,1.34 -8,4l0,2l16,0l0,-2c0,-2.66 -5.33,-4 -8,-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePerson);
export default __webpack_public_path__ + "static/media/BluePerson.d7b5e3d39b78cd4f01a36702ad07d868.svg";
export { ForwardRef as ReactComponent };